import React from 'react'

export const graficoOptions = {
  BarChart: {
    width: 500,
    height: 300,
    margin: {
      top: 40,
      right: 40,
      left: 20,
      bottom: 40,
    }
  },
  CartesianGrid: {
    stroke: '#e6e6e6',
    vertical: false
  },
  Brush: {
    dataKey: 'name',
    height: 30,
    stroke: '#4b5563',
    startIndex: 0,
    endIndex: 7,
  },
  XAxis: {
    dataKey: 'name',
    fontSize: '12px',
    stroke: '#6c7293',
    axisLine: false,
    tickLine: false,
  },
  YAxis: {
    unit: "%",
    fontSize: '12px',
    stroke: "#6c7293",
    axisLine: false,
    tickLine: false,
  },
  Bar: {
    radius: [6, 6, 6, 6],
    label: {
      fill: '#6c7293',
      unit: '%',
      fontSize: '11px',
    }
  }
}

export const CustomLabel = ({ x, y, width, value, payload }) => {
  const label = payload?.valueLabel || value

  return (
    <text
      x={x + (width / 2)}
      y={value < 0 ? y + 16 : y}
      dy={-4}
      fontSize={graficoOptions.Bar.label.fontSize}
      fill={graficoOptions.Bar.label.fill}
      textAnchor="middle"
    >
      {label}{payload?.hasData ? graficoOptions.Bar.label.unit : ''}
    </text>
  )
}

export const CustomTooltip = ({ active, payload, label, msgNA }) => {
  if (!active || !payload || !payload.length) {
    return null
  }

  const item = payload[0]?.payload
  const value = item?.hasData ? `${item.valueLabel}%` : msgNA

  return (
    <div className="custom-tooltip">
      <p className="label">{item?.tooltip || label}</p>
      <p className="desc">
        <span style={{ backgroundColor: item?.fill }}></span>
        {`SFI: ${value}`}
      </p>
      {item?.tipo === 'empresa' && item?.hasData && item?.deltaVsBenchmark !== undefined ? (
        <p className="desc">
          {`Gap vs Benchmark: ${Number(item.deltaVsBenchmark).toFixed(2)}`}
        </p>
      ) : null}
    </div>
  )
}